import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import httpRequest from "../../utils/Http";


const AssignEngineer = ({ bid, setReload, closeForm }) => {
  const [formData, setFormData] = useState({});
  const [englist, setEnglist] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    if (bid) {
      setFormData((prev) => ({ ...prev, id: bid }));
      (async () => {
        const scdata = await httpRequest(`getenglistforassignbooking?bid=${bid}`, {}, "GET");
        if (scdata.status === true && scdata.data) {
          setEnglist(scdata.data);
        } else {
          setEnglist([]);
        }
      })();
    }
  }, [bid]);


  const validateForm = (value) => {
    const errors = {};

    if (!value.eng_id) {
      errors.eng_id = "Engineer Name is required";
    }
    // if(!value.remarks){
    //     errors.remarks = "Remarks is required";
    // }
    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formData));
    setSubmit(true);
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest("processassignengineer", formData, "POST");

        if (data.status === true && data.message) {
          toast.success(data.message);
          setReload(true);
          closeForm();
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
  }, [isSubmit, formErrors, formData, setReload, closeForm]);

  return (
    <>
      <div className="form-overlay">
        <div className="form-container" style={{ maxWidth: "500px" }}>
          <div className="form-content">
            <form id="assignPartner" onSubmit={onSubmitHandler}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div className="card-header">
                      <h3 className="card-title">Assign Engineer</h3>
                      <button
                        type="button"
                        className="btn btn-sm btn-dark"
                        onClick={closeForm}
                        style={{ float: "right" }}
                      >
                        X
                      </button>
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Engineer *{" "}
                              <span style={{ color: "red" }}>
                                {formErrors.eng_id}
                              </span>
                            </label>
                            <Select
                              name="eng_id"
                              placeholder="Select Engineer Name"
                              value={englist.find((option) => option.value === formData.eng_id) || null}
                              options={englist}
                              onChange={(val) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  eng_id: val.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>
                              Remarks {" "}
                              <span style={{ color: "red" }}>
                                {formErrors.eng_id}
                              </span>
                            </label>
                            <textarea
                                name="remarks"
                                id="remarks"
                                value={formData.remarks}
                                placeholder="Enter remarks"
                                className="form-control"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    [e.target.name]: e.target.value,
                                  });
                                }}
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-footer text-center"
                      style={{
                        marginBottom: "60px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <button type="submit" id="submit" className="btn btn-primary col-md-12" style={{margin: "0px"}}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignEngineer;
